import React, { useEffect, useMemo, useState } from 'react'
import { useParams } from 'react-router-dom'
import { useQuery } from '@tanstack/react-query'
import SubscriptionsAPI from 'api/faber/SubscriptionsAPI'
import FaberBasicTab from 'common/FaberComponents/basic-components/FaberTab'
import PageLayoutV2 from 'common/Layout/Page/PageLayoutV2'
import { format } from 'date-fns'
import { changeMonth } from 'helpers/date'
import OrbitSession from 'hooks/useCookies'
import { SubscriptionsTableRows } from 'types/api/faber/subscription.type'

import FinanceV2OneUser from '../v2-customer-components/FinanceV2OneUser'
import UserProfileV2 from '../v2-customer-components/UserProfileV2'

function FaberViewProfilePage() {
  const { id } = useParams()
  const [endDate] = useState<Date>(changeMonth(new Date(), +3))
  const faberToken = OrbitSession.get('faberToken')
  const [customerData, setCustomerData] = useState<SubscriptionsTableRows>(
    {} as SubscriptionsTableRows
  )

  const { data: getAllSubscriptions } = useQuery(
    ['getAllSubscriptions', [id, endDate]],
    async () => {
      return SubscriptionsAPI.getAllSubscriptions(
        faberToken,
        10,
        0,
        [],
        [],
        'Customer ID',
        id ? id : '',
        'DESC',
        '2022-10-20',
        format(endDate, 'yyyy-MM-dd')
      )
    }
  )

  useEffect(() => {
    if (getAllSubscriptions) {
      const { data } = getAllSubscriptions.data.body
      const allSubscriptions: SubscriptionsTableRows[] = data.map(
        ({
          firstName,
          lastName,
          customerId,
          userEmail,
          msisdn,
          iccid,
          plan,
          status,
          startAt,
          cycleCount
        }) => ({
          firstName,
          lastName,
          userID: customerId,
          userEmail,
          iccid,
          planStatus: status,
          planName: plan,
          subscriptionStartAt: startAt,
          msisdn,
          cycleCount: String(cycleCount),
          countryCode: '+65'
        })
      )
      if (allSubscriptions.length > 0) {
        setCustomerData(allSubscriptions[0])
      }
    }
  }, [getAllSubscriptions])

  const allTabs = useMemo(() => {
    return [
      {
        tabTitle: 'Overview',
        tabContent: <UserProfileV2 customerRow={customerData} />,
        tabCategory: 'overview',
        passedData: customerData
      },
      {
        tabTitle: 'Finance',
        tabContent: <FinanceV2OneUser customerRow={customerData} />,
        tabCategory: 'finance',
        passedData: customerData
      }
    ]
  }, [customerData])

  return (
    <PageLayoutV2 header='Customer Details'>
      <FaberBasicTab tabInfo={allTabs} />
    </PageLayoutV2>
  )
}

export default FaberViewProfilePage
